import { render, staticRenderFns } from "./menu-pills.vue?vue&type=template&id=0499a60e&"
import script from "./menu-pills.vue?vue&type=script&lang=js&"
export * from "./menu-pills.vue?vue&type=script&lang=js&"
import style0 from "./menu-pills.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports